/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import { withNamespaces } from 'react-i18next';
import get from 'lodash/get';
import compose from 'lodash/fp/compose';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import { withConsumer } from '../../../contexts';
import { modalIds, ModalsConsumer } from '../../../contexts/ModalsContext';
import Modal from '../../ui/Modal';
import { Container } from '../../../styles/Grid';
import Spacer from '../../ui/Spacer';

import * as styles from './index.styles';
import Header from './Header';
import Cookies from 'universal-cookie';
import FormHolder from './FormHolder';
import SelectLocation from './SelectLocation';
import UserInfo from './UserInfo';
import SetDateTime from './SetDateTime';
import ThankYou from './ThankYou';
import Axios from 'axios';
import { Image } from '@sitecore-jss/sitecore-jss-react';
import moment from 'moment';
import AnimFormButton, { FormStateArr } from '../AnimFormButton';
import { Picture } from '../../ui/Picture';
import { Breakpoints } from '../../../styles/Grid/GridSizes';
import { CLOUDINARY_BASE_VALUES } from '../../../utils/constants';

function findNextInstanceInDaysArray() {
  if (moment().day() === 5) {
    // friday, show monday
    // set to monday
    return moment().weekday(8);
  } else if (moment().day() === 6) {
    // saturday, show monday
    // set to monday
    return moment().weekday(8);
  } else {
    // other days, show next day
    return moment().add('days', 1);
  }
}
class BookAVisit extends SafePureComponent {
  cookies = new Cookies();
  channelCookie = this.cookies.get('channel_attrib') || 'Organic';
  validationAction;

  state = {
    stepsData: {
      // step0: { location: 'location test', solution: 'solution test' },
      step0: { location: '', solution: '', locationId: '', solutionId: '' },
      step1: {
        name: '',
        email: '',
        phoneNumber: '',
        CountryISOCode2: '',
        CountryISOCode3: '',
        DialingCode: '',
      },
      step2: { date: '', time: '12:00 PM' },
    },
    activeStep: 0,
    formSuccess: false,

    formState: FormStateArr.DEFAULT,
  };

  setActiveStep = activeStep => {
    this.setState({ activeStep });
  };

  onAfterOpen = () => {
    // this.handleAnalyticsDataForCurrentStep();
  };

  onAfterClose = () => {
    this.setState({
      activeStep: 0,
      formSuccess: false,
      formState: FormStateArr.DEFAULT,
      stepsData: {
        // step0: { location: 'location test', solution: 'solution test' },
        step0: { location: '', solution: '', locationId: '', solutionId: '' },
        step1: {
          name: '',
          email: '',
          phoneNumber: '',
          CountryISOCode2: '',
          CountryISOCode3: '',
          DialingCode: '',
        },
        step2: { date: '', time: '12:00 PM' },
      },
    });
  };

  saveStepData = async values => {
    let { activeStep, stepsData } = this.state;
    stepsData['step' + activeStep] = values;
    // this.setState({ stepsData, activeStep: activeStep + 1 });
    if (activeStep === 2) {
      let Location = stepsData.step0.solutionId;
      // let solution = stepsData.step0.solution;

      let FullName = stepsData.step1.name;
      let Email = stepsData.step1.email;
      let PhoneNumber = stepsData.step1.phoneNumber;
      let DialingCode = stepsData.step1.DialingCode;
      let CountryISOCode2 = stepsData.step1.CountryISOCode2;
      let CountryISOCode3 = stepsData.step1.CountryISOCode3;
      let ChannelAttrib = this.channelCookie;
      // let BookingDate = moment(values.date, 'DD/MM/YYYY').format('D-M-YYYY');

      let BookingDate = values.date
        ? moment(values.date, 'DD/MM/YYYY').format('D-M-YYYY')
        : findNextInstanceInDaysArray().format('D-M-YYYY');
      values.date = moment(BookingDate, 'D-M-YYYY').format('MM/DD/YYYY');
      let BookingTime = values.time;
      stepsData['step' + activeStep] = values;

      let SubmitData = {
        FullName,
        Email,
        PhoneNumber,
        DialingCode,
        BookingDate,
        BookingTime,
        Location,
        DomainCountryISOCode2: CountryISOCode2,
        CountryISOCode3,
        ChannelAttrib,
      };

      // console.log('** xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx');
      // console.log('** SubmitData >> ', SubmitData, activeStep);
      this.changeFromState('PROGRESS');
      const SubmitApiURL = get(this.props.fields, 'SubmitApiURL.value', '');
      try {
        const res = await Axios.post(
          window.location.origin + '/' + SubmitApiURL,
          SubmitData,
        );

        if (res.status === 200) {
          this.setState({
            stepsData,
            activeStep: activeStep + 1,
            formSuccess: true,
          });
        }
        this.changeFromState('DEFAULT');
      } catch (error) {
        this.changeFromState('ERROR');
        this.setState({
          stepsData,
          activeStep: activeStep + 1,
          formSuccess: false,
        });
      }
    } else {
      this.setState({ stepsData, activeStep: activeStep + 1 });
    }
  };

  setValidationActionWrapper = action => {
    this.validationAction = () => action();
    // this.setState({ validationAction: () => action() });
  };

  runValidationAction = () => {
    // this.state.validationAction();
    if (this.validationAction) {
      this.validationAction();
    }
  };

  renderLocation = heading => {
    const {
      activeStep,
      stepsData: { step0 },
    } = this.state;

    const { fields } = this.props;
    const Step1ShortHeading = get(fields, 'Step1ShortHeading.value', '');

    const isActive = activeStep === 0;
    const haveData = step0.location;
    const showTitleWithData = !isActive && haveData;
    return (
      <div
        css={[
          styles.tabFormArea,
          (isActive || haveData) && styles.isActive,
          showTitleWithData && styles.haveData,
        ]}
      >
        {showTitleWithData ? (
          <h2
            onClick={() => haveData && this.setActiveStep(0)}
            className={[haveData && 'is-clickable']}
            aria-hidden="true"
          >
            1. {Step1ShortHeading}{' '}
            <span title={`${step0.solution}`}>{step0.solution}</span>
          </h2>
        ) : (
          <h2 aria-hidden="true" onClick={this.runValidationAction}>
            1. {heading}
          </h2>
        )}

        {isActive && (
          <SelectLocation
            fields={fields}
            lang={this.props.lng}
            setValidationAction={this.setValidationActionWrapper}
            onSaveStepData={this.saveStepData}
            {...step0}
          />
        )}
      </div>
    );
  };

  renderUserInfo = (
    heading,
    NameWatermark,
    EmailWatermark,
    PhoneNumberWatermark,
  ) => {
    const {
      activeStep,
      stepsData: { step1 },
    } = this.state;
    const { fields } = this.props;

    const isActive = activeStep === 1;
    const haveData = step1.name;

    const showTitleWithData = !isActive && haveData;
    const Step2ShortHeading = get(fields, 'Step2ShortHeading.value', '');

    const PhoneNumberRequiredErrorMessage = get(
      fields,
      'PhoneNumberRequiredErrorMessage.value',
      '',
    );
    const PhoneNumberInvalidErrorMessage = get(
      fields,
      'PhoneNumberInvalidErrorMessage.value',
      '',
    );

    return (
      <div
        css={[
          styles.tabFormArea,
          (isActive || haveData) && styles.isActive,
          showTitleWithData && styles.haveData,
        ]}
      >
        {showTitleWithData ? (
          <h2
            onClick={() => haveData && this.setActiveStep(1)}
            className={[haveData && 'is-clickable']}
            aria-hidden="true"
          >
            2. {Step2ShortHeading}
            <span title={`${step1.name}, ${step1.email}`}>
              {step1.name}, {step1.email}
            </span>
          </h2>
        ) : (
          <h2 aria-hidden="true" onClick={this.runValidationAction}>
            2. {heading}
          </h2>
        )}

        {isActive && (
          <UserInfo
            fields={fields}
            setValidationAction={this.setValidationActionWrapper}
            onSaveStepData={this.saveStepData}
            NameWatermark={NameWatermark}
            EmailWatermark={EmailWatermark}
            PhoneNumberWatermark={PhoneNumberWatermark}
            PhoneNumberRequiredErrorMessage={PhoneNumberRequiredErrorMessage}
            PhoneNumberInvalidErrorMessage={PhoneNumberInvalidErrorMessage}
            {...step1}
          />
        )}
      </div>
    );
  };

  renderDateTime = (heading, SelectDateButtonText, TimeSelectorWatermark) => {
    const {
      activeStep,
      stepsData: { step2 },
    } = this.state;

    const isActive = activeStep === 2;
    const haveData = step2.date && step2.time;
    return (
      <div
        css={[
          styles.tabFormArea,
          (activeStep >= 2 || haveData) && styles.isActive,
        ]}
      >
        <h2
          onClick={() =>
            activeStep === 2 || haveData
              ? this.setActiveStep(2)
              : this.runValidationAction()
          }
          // onClick={this.runValidationAction}
          className={haveData && 'is-clickable'}
          aria-hidden="true"
        >
          3. {heading}
        </h2>
        {isActive && (
          <SetDateTime
            setValidationAction={this.setValidationActionWrapper}
            onSaveStepData={this.saveStepData}
            SelectDateButtonText={SelectDateButtonText}
            TimeSelectorWatermark={TimeSelectorWatermark}
            {...step2}
          />
        )}
      </div>
    );
  };

  isModal = () => {
    const { fields } = this.props;

    const isModal = get(fields, 'isModal.value', false);

    return isModal;
  };

  changeFromState = state => {
    this.setState({ formState: FormStateArr[state] });
  };

  renderMainContainer = () => {
    const { activeStep, stepsData, formSuccess, formState } = this.state;

    const { fields, modalsContext } = this.props;
    const { closeModal } = modalsContext;

    const Step1Heading = get(fields, 'Step1Heading.value', '');
    const Step2Heading = get(fields, 'Step2Heading.value', '');
    const Step3Heading = get(fields, 'Step3Heading.value', '');
    const EmailWatermark = get(fields, 'EmailWatermark.value', '');
    const NameWatermark = get(fields, 'NameWatermark.value', '');
    const PhoneNumberWatermark = get(fields, 'PhoneNumberWatermark.value', '');
    // const SelectDateButtonText = get(fields, 'SelectDateButtonText.value', '');
    const SelectDateButtonText = get(fields, 'DateSelectorWatermark.value', '');

    const TimeSelectorWatermark = get(
      fields,
      'TimeSelectorWatermark.value',
      '',
    );
    const NextButtonText = get(fields, 'NextButtonText.value', '');
    const SubmitButtonText = get(fields, 'SubmitButtonText.value', '');
    const isModal = this.isModal();
    const Image = get(fields, 'Image', false);
    const mainImageSizes = {
      [Breakpoints.sm]: {},
      [Breakpoints.md]: {},
      [Breakpoints.lg]: {
        ...CLOUDINARY_BASE_VALUES,
      },
      [Breakpoints.xl]: {
        ...CLOUDINARY_BASE_VALUES,
        width: 802,
        height: 600,
        gravity: 'auto:subject',
      },
    };

    return (
      <Container
        className={[styles.itemsContainerCss, !isModal && styles.pageComponent]}
      >
        <div>
          <Header
            fields={fields}
            onRequestClose={closeModal}
            activeStep={activeStep}
            isModal={isModal}
          />
          <div className="mid_sec">
            <div className="leftside">
              <div className="left_mid_sec">
                <div className="form_sec">
                  <FormHolder activeStep={activeStep}>
                    {activeStep < 3 && this.renderLocation(Step1Heading)}
                    {activeStep < 3 &&
                      this.renderUserInfo(
                        Step2Heading,
                        NameWatermark,
                        EmailWatermark,
                        PhoneNumberWatermark,
                      )}
                    {activeStep < 3 &&
                      this.renderDateTime(
                        Step3Heading,
                        SelectDateButtonText,
                        TimeSelectorWatermark,
                      )}
                    {activeStep === 3 && (
                      <ThankYou
                        fields={fields}
                        formSuccess={formSuccess}
                        closeModal={closeModal}
                        stepsData={stepsData}
                        isModal={isModal}
                        reTryBtn={this.onAfterClose}
                      />
                    )}
                  </FormHolder>

                  {/* <div>
                    <button onClick={() => this.setActiveStep(0)}>1</button>
                    <button onClick={() => this.setActiveStep(1)}>2</button>
                    <button onClick={() => this.setActiveStep(2)}>3</button>
                    <button onClick={() => this.setActiveStep(3)}>
                      Thank you
                    </button>
                  </div> */}
                </div>

                <div className="next_btn">
                  {activeStep < 3 && (
                    <AnimFormButton
                      label={
                        activeStep == 2 ? SubmitButtonText : NextButtonText
                      }
                      // formState={FormStateArr.DEFAULT}
                      formState={formState}
                      buttonProps={{
                        // disabled: isSubmitting,
                        onClick: () => {
                          this.runValidationAction();
                        },
                        css: [],
                        className: activeStep == 2 ? 'submit-btn' : 'next-btn',
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="rightside">
              {Image && (
                <Picture
                  image={Image}
                  imageSizes={mainImageSizes}
                  pictureCss={styles.previewImageStyleImage}
                  editable={false}
                />
              )}
            </div>
          </div>
        </div>
      </Container>
    );
  };

  safeRender() {
    const { modalsContext } = this.props;

    const { currentModal, closeModal } = modalsContext;

    if (this.isModal()) {
      return (
        <React.Fragment>
          {/* <button onClick={() => openModal(modalIds.bookVisit, {})}>
            open Book visit modal
          </button> */}
          <Modal
            isOpen={currentModal === modalIds.bookVisit}
            // isOpen={true}
            onRequestClose={closeModal}
            onAfterOpen={this.onAfterOpen}
            onAfterClose={this.onAfterClose}
            hideDefaultCloseButton
          >
            {this.renderMainContainer()}
          </Modal>
        </React.Fragment>
      );
    }
    return <Spacer>{this.renderMainContainer()}</Spacer>;
  }
}

BookAVisit.displayName = 'BookAVisit';

BookAVisit.defaultProps = {
  closeModal: () => {},
  isModal: false,
  t: key => key,
};

export default compose(
  withNamespaces(),
  withConsumer(ModalsConsumer, 'modalsContext'),
)(BookAVisit);
